<div [formGroup]="form">
  <div class="param-row">
    <mat-form-field appearance="fill"
             (click)="showMenu($event)"
             [ngClass]="{width100: simpleMode}">
      <mat-label>{{ label }}</mat-label>
      <input matInput
             [value]="indicator_name"
             [matMenuTriggerFor]="indicatorMenu"
             readonly>
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
    </mat-form-field>

    <mat-menu #indicatorMenu="matMenu">
      <ng-container *ngFor="let group of options$ | async; let l = count">
        <ng-container *ngIf="l > 1 else withoutSubmenuRef">
          <button [matMenuTriggerFor]="sub_menu"
                  mat-menu-item>{{ group.name }}</button>
          <mat-menu #sub_menu="matMenu" xPosition="before">
            <button *ngFor="let child of group.children"
                    (click)="selectIndicator(child)"
                    [matTooltip]="child.name.length > 77 ? child.name : null"

                    mat-menu-item>{{ child.name }}</button>
          </mat-menu>
        </ng-container>
        <ng-template #withoutSubmenuRef>
            <button *ngFor="let child of group.children"
                    (click)="selectIndicator(child)"
                    [matTooltip]="child.name.length > 77 ? child.name : null"
                    mat-menu-item>{{ child.name }}</button>
        </ng-template>
      </ng-container>
    </mat-menu>

    <div class="param-row__check-list" *ngIf="showCheckboxes">
      <mat-checkbox *ngIf="showColor"
                    [disabled]="form.value.group2_color == true"
                    formControlName="color">Цвет</mat-checkbox>
      <mat-checkbox *ngIf="showForm"
                    [disabled]="form.value.group2_form == true"
                    formControlName="form">Форма</mat-checkbox>
      <mat-checkbox *ngIf="showSplit"
                    formControlName="split">Разделить</mat-checkbox>
      <mat-checkbox *ngIf="showUniX"
                    formControlName="uni_x">Единая ось X</mat-checkbox>
      <mat-checkbox *ngIf="showUniY"
                    formControlName="uni_y">Единая ось Y</mat-checkbox>
    </div>
    <div>
      <button mat-icon-button *ngIf="showRemoveBtn" matTooltip="Удалить" (click)="remove()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>

  </div>
  <div class="param-row" *ngIf="form.value.indicator == 'country__continent' && form.value.split === true && (visualization.value == 'scatter' || visualization.value == 'boxplot' || visualization.value == 'violin' || visualization.value == 'bar')">
    <div class="param-row__select">
      <mat-form-field appearance="fill" class="width180">
        <mat-label>Группировка 2</mat-label>
        <mat-select [formControl]="form.controls.group2">
          <mat-option [value]="null"></mat-option>
          <mat-option value="country">Страна</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="param-row__check-list">
        <mat-checkbox [disabled]="form.value.color == true"
                      [formControl]="form.controls.group2_color">Цвет</mat-checkbox>
        <mat-checkbox *ngIf="visualization.value == 'scatter'" [disabled]="form.value.form == true"
                      [formControl]="form.controls.group2_form">Форма</mat-checkbox>
    </div>
  </div>
</div>

